var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from "react";
import { observer } from "mobx-react";
import { SuperBannerItem, SuperBannerLoader, SuperBannerImage, SuperBannerEvent } from "../../components";
let SuperBannerSportsItem = class SuperBannerSportsItem extends React.PureComponent {
    render() {
        const { item, itemWidth, onImageClick, onBetButtonClick } = this.props;
        return (React.createElement(SuperBannerItem, { key: item.id, clientHashedClass: item.ClientHashClass, clientHashedAttribute: item.ClientHashAttribute, modifier: this.getModifier(), width: itemWidth, shouldRemoveContent: item.ImageUIProps.shouldRemoveContent },
            item.isLoading && React.createElement(SuperBannerLoader, null),
            this.renderImage() && React.createElement(SuperBannerImage, Object.assign({}, this.props, { onClick: onImageClick, item: item })),
            item.EventUIPops && React.createElement(SuperBannerEvent, Object.assign({}, this.props, { onClick: onBetButtonClick, eventInfo: item.EventUIPops }))));
    }
    renderImage() {
        return !this.props.displayMobileMode && !this.showOutrightItem();
    }
    getModifier() {
        if (this.showOutrightItem()) {
            return !this.props.displayMobileMode ? this.props.getSuperBannerItemModifier(this.props.item) : "";
        }
        return this.props.getSuperBannerItemModifier(this.props.item);
    }
    showOutrightItem() {
        var _a;
        return (this.props.displayMultipleItems || this.props.displayMobileMode)
            && ((_a = this.props.item.EventUIPops) === null || _a === void 0 ? void 0 : _a.pickedEvent.IsOutright);
    }
};
SuperBannerSportsItem = __decorate([
    observer
], SuperBannerSportsItem);
export { SuperBannerSportsItem };
//# sourceMappingURL=SuperBannerSportsItem.js.map